import { ContentSearchResultEntry } from '../services';

export const transformContentSearchResults = (data: ContentSearchResultEntry[]) =>
  data.map(({ title, snippets, display_link }) => ({
    title,
    description: snippets?.[0] ?? '',
    link: display_link,
  }));
